import React, { useEffect } from 'react';
import AppRouter from './routing/AppRouter';
import { useBranding } from './hooks/useBranding';

function App() {
  useBranding();
  
  useEffect(() => {
    console.log('Commit hash:', __COMMIT_HASH__);
    const comment = document.createComment(` COMMIT: ${__COMMIT_HASH__} `);
    document.body.appendChild(comment);
  }, []);
  
  return <AppRouter />;
}

export default App;
